
import Experience from "./Experience/Experience.js"

new Experience(document.querySelector("canvas.webgl"))
